/**
 * Preseed Constants
 *
 * Preseed-specific constants including type labels, status mappings, etc.
 *
 * Pattern matches:
 * - src/sections/seeds/config/constants.tsx
 */

import { Preseed } from '@/types';

// ============================================================================
// TYPE LABELS
// ============================================================================

/**
 * Human-readable labels for preseed types
 */
export const PreseedTypeLabel: Record<Preseed['type'], string> = {
  csp: 'Content Security Policy',
  cik: 'EDGAR CIK',
  'edgar+company': 'EDGAR Entity',
  favicon: 'Favicon',
  tlscert: 'Certificate',
  'whois+company': 'WHOIS',
  'whois+email': 'WHOIS',
  'whois+name': 'WHOIS',
  analytics: 'Analytics',
  'cidr-handle': 'CIDR Handle',
};

// ============================================================================
// TABLE CONFIGURATION
// ============================================================================

/**
 * Preseed-specific table configuration
 */
export const PRESEED_TABLE_CONFIG = {
  defaultRowHeight: 68, // Taller rows for type/value display
  enableSelection: true,
  enableKeyboardNavigation: true,
  storageKey: 'seeds-preseed-v1',
} as const;
